(ns client-portal.client.voice-insights.items.data
  (:require [client-portal.client.core.data :as core.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.concepts.data :as concepts.d]
            [shared.core.router :as router]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:voice-insights :items])
(def by-concept-id-path (conj root-path :by-concept-id))
(def conversation-count-by-concept-id-path (conj root-path :conversation-count-by-concept-id))

(defn full-color-from-string [item]
  (util/str->hex (if (map? item) (or (:item item) (:label item)) item)))

(defn item-color [item & {:keys [opacity]}]
  (-> (full-color-from-string item)
      (util/hex->rgba (or opacity 0.5))))

(re/reg-sub
  :vi-items/view-mode-
  (fn [db]
    (or (:ivm (router/current-query-params db)) "charts")))

(re/reg-event-db
  :vi-items/select-view-mode re/middleware
  (fn [db [mode]]
    (re/dispatch [:router/go-with-merged-query-params {:ivm mode}])
    db))

(re/reg-event-db
  :vi-items/initialize-filters re/middleware
  (fn [db]
    (core.d/initialize-common-filters db)))

(re/reg-event-db
  :vi-items/reload re/middleware
  (fn [db]
    (-> db
        (assoc-in conversation-count-by-concept-id-path nil)
        (assoc-in (conj root-path :charts :data) nil)
        (update-in (conj root-path :comparison :items) (fn [items]
                                                         (some->> items
                                                                  (mapv (fn [[idx item]]
                                                                          [idx (dissoc item :data)]))
                                                                  (into {})))))))

(re/reg-event-fx
  :vi-items/initialize re/middleware
  (fn [{:keys [db]}]
    (re/dispatch [:vi-items/initialize-filters])
    (re/dispatch [:vi-items/init-comparison-items])
    (re/dispatch [:vi-items/reload])
    {:db db
     :forward-events {:register :vi-items-initialization-listener
                      :events #{:concepts/select :locations/select :core/select-crew-type
                                :core/select-timeframe :locations/clear-selected
                                :core/timeframe-date-range-changed}
                      :dispatch-to [:vi-items/reload]}}))

(defn current-items-list [db]
  (when-let [concept-id (concepts.d/current-concept-id db)]
    (get-in db (conj by-concept-id-path concept-id))))

(re/reg-auth0-loader
  :vi-items/load-list
  (fn [[concept-id]]
    (conj by-concept-id-path concept-id))
  (fn [db concept-id]
    (when (vi.d/menu-items-feature-enabled? (vi.d/concept-configuration db))
      {:method :post
       :url "/api/vi/items/list"
       :json-params (dissoc (vi.d/base-query-args db {:timeframe 90
                                                      :concept-id concept-id})
                            :crew-type)}))
  :transf (fn [resp] (or (some->> resp :body (util/->kebab-case-keywords) (sort-by :item))
                         []))
  :error-transf (fn [] []))

(re/reg-sub
  :vi-items/list-by-current-concept-id-
  (fn [db]
    (let [concept-id (concepts.d/current-concept-id db)
          v (current-items-list db)]
      (if (and concept-id (nil? v))
        (re/dispatch-load [:vi-items/load-list concept-id])
        v))))

(re/reg-auth0-loader
  :vi-items/load-conversations-count
  (fn [[concept-id]]
    (conj conversation-count-by-concept-id-path concept-id))
  (fn [db concept-id]
    {:method :post
     :url "/api/vi/conversations/count"
     :json-params (vi.d/base-query-args db {:concept-id concept-id})})
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords) :count)
                         0))
  :error-transf (fn [] 0))

(re/reg-sub
  :vi-items/conversations-count-by-current-concept-id-
  (fn [db]
    (let [concept-id (concepts.d/current-concept-id db)
          v (when concept-id
              (get-in db (conj conversation-count-by-concept-id-path concept-id)))]
      (if (and concept-id (nil? v))
        (re/dispatch-load [:vi-items/load-conversations-count concept-id])
        v))))
